import React from "react";

const formatResultDate = (timestamp) => {
    if (!timestamp) return "";

    const date = new Date(Number(timestamp) * 1000);

    if (isNaN(date.getTime())) return "";

    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;

    return `${month}/${day}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};

function parseCards(result) {
    if (!result) return [];

    return String(result)
        .split(",")
        .map((card) => card.trim())
        .filter(Boolean);
}

const LotteryResult = ({ resultData }) => {
    return (
        <div className="left-content">

            {resultData?.map((row, index) => {
                console.log("Lottery row:", row);
                const cards = parseCards(row.result);

                return (

                    <div
                        key={index}
                        className="card"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            padding: "10px",
                            marginBottom: "5px",
                            background:
                                "linear-gradient(rgb(15,15,15), rgb(251,251,251))",
                            color: "#fff"
                        }}
                    >

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                fontWeight: "bold",
                                fontSize: "16px"
                            }}
                        >
                            <span>
                                {formatResultDate(row.cat_mid)} - <b>ID=</b> {row.cat_mid}
                            </span>
                        </div>

                        <hr
                            style={{
                                borderColor: "#444"
                            }}
                        />

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center"
                            }}
                        >

                            <div
                                className="dealer-result-box"
                                style={{
                                    width: "320px",
                                    borderRadius: "15px",
                                    background:
                                        "linear-gradient(#555,#171717)",
                                    textAlign: "center"
                                }}
                            >

                                <div
                                    className="dealer-cards"
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: "18px",
                                        gap: "4px",
                                        marginBottom: "5px"
                                    }}
                                >
                                    Dealer
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center", marginBottom: "5px"
                                    }}
                                >
                                    {cards.map((card, i) => (

                                        <img
                                            key={i}
                                            src={`/assets/images/cards/${card}.svg`}
                                            alt=""
                                            style={{
                                                width: "45px", height: "55px"
                                            }}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
            <style>
                {` 
                    @media(max-width:576px){
                        .mobile-margin{
                            margin-top: 2px !important;
                            margin-left: 2px !important;
                        }
                        hr {
                            margin-top: 2px !important;
                            margin-bottom: 5px !important;
                        }
                        .dealer-result-box {
                            width: 100% !important;
                            box-sizing: border-box !important;
                        }
                        .dealer-cards {
    gap: 1px !important;
  }

  .dealer-cards img {
    margin: 0 !important;
    padding: 0 !important;
    display: block !important;
  }
                    }
                `}
            </style>
        </div>
    );
};

export default LotteryResult;